/**
 * LINE 표시 이름에서 실제로 유입된 티베트 결합 부호(U+0F71~U+0F84)를 포함해,
 * 이름으로 지원하지 않는 이모지 구성요소와 기호를 제거한다.
 */
const UNSUPPORTED_SYMBOL_CATEGORY_PATTERN = /\p{So}|\p{Sk}|\p{Me}/u

export const DEFAULT_USER_DISPLAY_NAME = 'PODO user'

const isBetween = (value: number, start: number, end: number) => value >= start && value <= end

const isUnsupportedDisplayNameCharacter = (character: string) => {
  const codePoint = character.codePointAt(0)
  if (codePoint === undefined) {
    return false
  }

  return (
    UNSUPPORTED_SYMBOL_CATEGORY_PATTERN.test(character) ||
    isBetween(codePoint, 0x1f000, 0x1faff) ||
    isBetween(codePoint, 0x2600, 0x27bf) ||
    isBetween(codePoint, 0x2300, 0x23ff) ||
    isBetween(codePoint, 0x2190, 0x21ff) ||
    isBetween(codePoint, 0x2b00, 0x2bff) ||
    isBetween(codePoint, 0x2934, 0x2935) ||
    isBetween(codePoint, 0x1f1e6, 0x1f1ff) ||
    isBetween(codePoint, 0x1f3fb, 0x1f3ff) ||
    isBetween(codePoint, 0xe0020, 0xe007f) ||
    isBetween(codePoint, 0xfe00, 0xfe0f) ||
    isBetween(codePoint, 0xe0100, 0xe01ef) ||
    isBetween(codePoint, 0x0f71, 0x0f84) ||
    codePoint === 0x200d ||
    codePoint === 0x20e3 ||
    codePoint === 0x3030 ||
    codePoint === 0x303d ||
    codePoint === 0x3297 ||
    codePoint === 0x3299
  )
}

const removeUnsupportedDisplayNameCharacters = (value: string) =>
  Array.from(value.normalize('NFC'))
    .filter((character) => !isUnsupportedDisplayNameCharacter(character))
    .join('')

/** 입력 중 마지막 공백은 유지해 복수 단어 이름을 계속 입력할 수 있게 한다. */
export const sanitizeUserDisplayNameInput = (value: string) =>
  removeUnsupportedDisplayNameCharacters(value).replace(/\s+/g, ' ').trimStart()

/** 저장할 이름은 앞뒤 공백까지 제거한다. */
export const sanitizeUserDisplayName = (value: string) => sanitizeUserDisplayNameInput(value).trim()

/** 외부 프로필/저장 경계에서는 이름이 모두 제거되면 안전한 기본 이름을 사용한다. */
export const sanitizeUserDisplayNameOrDefault = (value: string) =>
  sanitizeUserDisplayName(value) || DEFAULT_USER_DISPLAY_NAME
